"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1346],{

/***/ 32641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Editor; }
});

// NAMESPACE OBJECT: ./src/form/services/iframesdk.ts
var iframesdk_namespaceObject = {};
__webpack_require__.r(iframesdk_namespaceObject);
__webpack_require__.d(iframesdk_namespaceObject, {
  "test": function() { return test; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/form/components/form/modules/index.tsx + 18 modules
var modules = __webpack_require__(5064);
// EXTERNAL MODULE: ./src/form/hooks/useForm.tsx
var useForm = __webpack_require__(13810);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/form/components/common/icons.tsx
var icons = __webpack_require__(85119);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/ScrollArea/ScrollArea.js + 12 modules
var ScrollArea = __webpack_require__(73723);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./src/form/utils/format.ts
var format = __webpack_require__(54423);
// EXTERNAL MODULE: ./src/stores/index.ts + 23 modules
var stores = __webpack_require__(27234);
// EXTERNAL MODULE: ./src/form/services/campaign.ts
var campaign = __webpack_require__(34913);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./node_modules/mixpanel-browser/dist/mixpanel.cjs.js
var mixpanel_cjs = __webpack_require__(8891);
var mixpanel_cjs_default = /*#__PURE__*/__webpack_require__.n(mixpanel_cjs);
;// CONCATENATED MODULE: ./src/form/hooks/useVerifyCampaign.ts







function useVerifyCampaign(field) {
    var ref = (0,react.useState)(false), submiting = ref[0], setSubmiting = ref[1];
    var ref1 = (0,react.useState)(), submitError = ref1[0], setSubmitError = ref1[1];
    var ref2 = (0,stores/* useTypedSelector */.ix)(function(state) {
        return state.campaignVerify;
    }), result = ref2.result, form = ref2.form;
    (0,react.useEffect)(function() {
        if (field) {
            stores/* default.dispatch */.ZP.dispatch(stores/* actions.campaignVerify.register */.Nw.campaignVerify.register(field));
            return function() {
                stores/* default.dispatch */.ZP.dispatch(stores/* actions.campaignVerify.unRegister */.Nw.campaignVerify.unRegister(field));
            };
        }
    }, [
        field
    ]);
    var changeVerifyState = (0,react.useCallback)(function(state) {
        if (field) {
            stores/* default.dispatch */.ZP.dispatch(stores/* actions.campaignVerify.changeVerifyState */.Nw.campaignVerify.changeVerifyState({
                field: field,
                state: state
            }));
        }
    }, [
        field
    ]);
    var changeForm = (0,react.useCallback)(function(value) {
        if (field) {
            stores/* default.dispatch */.ZP.dispatch(stores/* actions.campaignVerify.changeForm */.Nw.campaignVerify.changeForm({
                field: field,
                value: value
            }));
        }
    }, [
        field
    ]);
    var submit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ref, res, e, ref1, message;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setSubmiting(true);
                        setSubmitError(undefined);
                        return [
                            4,
                            (0,campaign/* submit */.Ps)(data)
                        ];
                    case 1:
                        res = _state.sent();
                        mixpanel_cjs_default().track("submit_form", {
                            form_id: data.campaign_id,
                            is_submit_success: true,
                            name: data.campaign_name,
                            source: data === null || data === void 0 ? void 0 : (ref = data.context) === null || ref === void 0 ? void 0 : ref.source
                        });
                        return [
                            2,
                            res
                        ];
                    case 2:
                        e = _state.sent();
                        try {
                            message = JSON.parse(e.message);
                            setSubmitError(message);
                        } catch (err) {
                            react_toastify_esm/* toast.error */.Am.error(e.message);
                        }
                        mixpanel_cjs_default().track("submit_form", {
                            form_id: data.campaign_id,
                            is_submit_success: false,
                            submit_failed: e.message,
                            name: data.campaign_name,
                            source: data === null || data === void 0 ? void 0 : (ref1 = data.context) === null || ref1 === void 0 ? void 0 : ref1.source
                        });
                        return [
                            2,
                            false
                        ];
                    case 3:
                        setSubmiting(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var verified = true;
    for(var prop in result){
        if (!result[prop]) {
            verified = false;
            break;
        }
    }
    return {
        changeVerifyState: changeVerifyState,
        result: result,
        verified: verified,
        submit: submit,
        submiting: submiting,
        submitError: submitError,
        changeForm: changeForm,
        form: form
    };
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(94491);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/utils/clamp/clamp.js
var clamp = __webpack_require__(9276);
;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-counter/use-counter.js



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const DEFAULT_OPTIONS = {
  min: -Infinity,
  max: Infinity
};
function useCounter(initialValue = 0, options) {
  const { min, max } = __spreadValues(__spreadValues({}, DEFAULT_OPTIONS), options);
  const [count, setCount] = (0,react.useState)((0,clamp/* clamp */.u)(initialValue, min, max));
  const increment = () => setCount((current) => (0,clamp/* clamp */.u)(current + 1, min, max));
  const decrement = () => setCount((current) => (0,clamp/* clamp */.u)(current - 1, min, max));
  const set = (value) => setCount((0,clamp/* clamp */.u)(value, min, max));
  const reset = () => setCount((0,clamp/* clamp */.u)(initialValue, min, max));
  return [count, { increment, decrement, set, reset }];
}


//# sourceMappingURL=use-counter.js.map

;// CONCATENATED MODULE: ./src/form/components/campaign/RedirectModal.tsx






var Stage;
(function(Stage) {
    Stage[Stage["pending"] = 0] = "pending";
    Stage[Stage["countdown"] = 1] = "countdown";
})(Stage || (Stage = {}));
var RedirectModal = function(param) {
    var opened = param.opened, setOpened = param.setOpened, link = param.link;
    var ref = (0,react.useState)(Stage.pending), stage = ref[0], setStage = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(useCounter(5, {
        min: 0,
        max: 5
    }), 2), count = ref1[0], handlers = ref1[1];
    var countRef = (0,react.useRef)({
        timer: null
    });
    var close = (0,react.useCallback)(function() {
        setStage(Stage.pending);
        handlers.reset();
        setOpened(false);
    }, []);
    (0,react.useEffect)(function() {
        if (link && opened) {
            setStage(Stage.countdown);
        }
    }, [
        link,
        opened
    ]);
    (0,react.useEffect)(function() {
        if (stage === Stage.countdown) {
            countRef.current.timer = setInterval(function() {
                handlers.decrement();
            }, 1000);
            return function() {
                clearInterval(countRef.current.timer);
            };
        }
    }, [
        stage
    ]);
    (0,react.useEffect)(function() {
        if (count === 0 && opened && link) {
            window.location.href = link;
            close();
        }
    }, [
        count,
        link,
        close,
        opened
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        centered: true,
        opened: opened,
        trapFocus: true,
        withCloseButton: false,
        onClose: close,
        classNames: {
            content: "!bg-bg_light_blue dark:!bg-[#1D283C]"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center text-center pb-[60px] pt-10 px-2 relative dark:text-gray_f9",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full h-full absolute left-0 top-0 flex items-center justify-center font-bold text-body",
                            children: count
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LoadIcon */.Tl, {
                            className: "animate-spin"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "font-bold mt-7",
                    children: "You’re being redirected to another site"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center mt-2",
                    children: "The form owner wants to redirect you to their site. This will open in a new tab in the same window."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                    className: "absolute top-0 right-0 fill-primary h-3 w-3 cursor-pointer",
                    onClick: close
                })
            ]
        })
    });
};
/* harmony default export */ var campaign_RedirectModal = (RedirectModal);

// EXTERNAL MODULE: ./src/form/services/response.ts
var response = __webpack_require__(23365);
// EXTERNAL MODULE: ./src/form/hooks/useAccount.tsx
var useAccount = __webpack_require__(74963);
;// CONCATENATED MODULE: ./src/form/hooks/useCampaignResponseStatus.ts





function useCampaignResponseStatus(id) {
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var isLogin = (0,useAccount/* default */.Z)().isLogin;
    var ref1 = (0,react.useState)(null), status = ref1[0], setStatus = ref1[1];
    var form = (0,stores/* useTypedSelector */.ix)(function(state) {
        return state.campaignVerify.form;
    });
    (0,react.useEffect)(function() {
        if (id && isLogin) {
            setLoading(true);
            (0,response/* getResponseStatus */.Aq)(id).then(function(res) {
                setStatus(res);
                if (!res) {
                    return;
                }
                stores/* default.dispatch */.ZP.dispatch(stores/* actions.campaignVerify.changeForm */.Nw.campaignVerify.changeForm({
                    field: "id",
                    value: res.id
                }));
                if (res.email) {
                    stores/* default.dispatch */.ZP.dispatch(stores/* actions.campaignVerify.changeForm */.Nw.campaignVerify.changeForm({
                        field: "email",
                        value: res.email
                    }));
                }
                if (res.context.question) {
                    stores/* default.dispatch */.ZP.dispatch(stores/* actions.campaignVerify.changeForm */.Nw.campaignVerify.changeForm({
                        field: "question",
                        value: res.context.question
                    }));
                }
            }).catch(function(e) {
                react_toastify_esm/* toast.error */.Am.error(e.message);
            }).finally(function() {
                setLoading(false);
            });
        }
    }, [
        id,
        isLogin
    ]);
    return {
        form: form,
        loading: loading,
        status: status,
        setStatus: setStatus
    };
}

// EXTERNAL MODULE: ./src/form/components/common/SuccessModal.tsx
var SuccessModal = __webpack_require__(49003);
// EXTERNAL MODULE: ./src/components/common/PageHead.tsx
var PageHead = __webpack_require__(47270);
// EXTERNAL MODULE: ./src/form/config/config.js
var config = __webpack_require__(28518);
// EXTERNAL MODULE: ./src/hooks/useAccount.tsx
var hooks_useAccount = __webpack_require__(98786);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./src/form/services/iframesdk.ts
function test(context) {
    console.log("api test", context);
}

;// CONCATENATED MODULE: ./src/form/hooks/useEditMessage.tsx





function callback(callbackId, data, error) {
    if (!callbackId) {
        return;
    }
    if (!parent) {
        return;
    }
    var origin = new URL(window.location.href).origin;
    if (error) {
        parent.postMessage({
            type: "callback_resp",
            callbackId: callbackId,
            error: error.message
        }, origin);
    } else {
        parent.postMessage({
            type: "callback_resp",
            callbackId: callbackId,
            data: data
        }, origin);
    }
}
function useEditMessage(context) {
    var contextRef = (0,react.useRef)({});
    (0,react.useEffect)(function() {
        contextRef.current = context;
        parent && parent.postMessage({
            type: "context_change",
            data: JSON.stringify(context)
        }, "*");
    }, [
        context
    ]);
    var handleMessage = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var result, callbackId, type, method, data, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        callbackId = lodash_default().get(e.data, "callbackId");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!(e.origin === "http://localhost:3001")) return [
                            3,
                            4
                        ];
                        console.log("handleMessage", e);
                        type = lodash_default().get(e.data, "type");
                        if (!(type === "api")) return [
                            3,
                            3
                        ];
                        method = lodash_default().get(e.data, "method");
                        data = lodash_default().get(e.data, "data");
                        // @ts-ignore
                        if (!iframesdk_namespaceObject[method]) {
                            throw new Error("".concat(method, " not support"));
                        }
                        return [
                            4,
                            iframesdk_namespaceObject[method].apply(contextRef.current, data)
                        ];
                    case 2:
                        // @ts-ignore
                        result = _state.sent();
                        _state.label = 3;
                    case 3:
                        if (type === "init") {
                            result = {
                                apiList: Object.keys(iframesdk_namespaceObject)
                            };
                        }
                        if (typeof result !== "undefined") {
                            callback(callbackId, result);
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e1 = _state.sent();
                        console.error(e1);
                        callback(callbackId, undefined, e1);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        contextRef
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("message", handleMessage, false);
        return function() {
            window.removeEventListener("message", handleMessage, false);
        };
    }, []);
}

// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./src/form/utils/request.js
var request = __webpack_require__(7395);
;// CONCATENATED MODULE: ./src/form/services/wallet.ts



var verifyBalance = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request/* default.rpc */.Z.rpc("wallet/verify_balance", data)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function verifyBalance(data) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/form/hooks/useVerifyBalance.ts


function useVerifyBalance(token, address, amount) {
    var ref = (0,react.useState)(false), verifySuccess = ref[0], setVerifySuccess = ref[1];
    var ref1 = (0,react.useState)(false), verifying = ref1[0], setVerifying = ref1[1];
    var ref2 = (0,react.useState)(""), error = ref2[0], setError = ref2[1];
    (0,react.useEffect)(function() {
        if (!token || !address || typeof amount === "undefined") {
            setVerifySuccess(false);
            setVerifying(false);
            setError("");
            return;
        }
        setVerifying(true);
        verifyBalance({
            token: token,
            user_address: address,
            amount: amount
        }).then(function(res) {
            setVerifySuccess(res);
        }).catch(function(e) {
            setError(e.message);
        }).finally(function() {
            setVerifying(false);
        });
    }, [
        token,
        address,
        amount
    ]);
    return {
        verifySuccess: verifySuccess,
        verifying: verifying,
        error: error
    };
}

// EXTERNAL MODULE: ./src/form/services/network.ts
var network = __webpack_require__(16385);
;// CONCATENATED MODULE: ./src/form/components/campaign/TokenBalanceVerify.tsx







var TokenBalanceVerify = function(param) {
    var verify = param.verify, setWalletQualified = param.setWalletQualified, needVerify = param.needVerify;
    var ref;
    var address = (0,dist/* useAccount */.mA)().address;
    var verifySuccess = useVerifyBalance(verify.values.token, address, verify.values.amount).verifySuccess;
    var ref1 = useVerifyCampaign("token_balance"), changeVerifyState = ref1.changeVerifyState, result = ref1.result;
    var showSignError = needVerify && !result.token_balance;
    (0,react.useEffect)(function() {
        changeVerifyState(verifySuccess);
        setWalletQualified(verifySuccess);
    }, [
        verifySuccess
    ]);
    var chain = network/* AvailableNetworks.find */.AE.find(function(network) {
        return String(network.config.id) === verify.values.chain;
    });
    var desc = "Wallet has at least ".concat(verify.values.amount, " ").concat((ref = verify.values.token) === null || ref === void 0 ? void 0 : ref.name, " on ").concat(chain === null || chain === void 0 ? void 0 : chain.name, " Chain");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2 py-2 px-4 bg-gray_f9 rounded-lg flex items-center justify-between dark:bg-[#192844] ".concat(showSignError ? "bg-error/10 border border-error" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-body text-dark1 dark:text-[#F9F9F9]",
                        children: desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckIcon */.nQ, {
                        className: "".concat(verifySuccess ? "fill-green dark:fill-dark_green" : "dark:fill-[#94949C]")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-error text-sm mt-1 ".concat(showSignError && address ? "flex" : "hidden"),
                children: "This is required"
            })
        ]
    });
};
/* harmony default export */ var campaign_TokenBalanceVerify = (TokenBalanceVerify);

;// CONCATENATED MODULE: ./src/form/components/campaign/WalletVerify.tsx











var WalletVerify = function(param) {
    var holding = param.holding, available = param.available, needVerify = param.needVerify;
    var ref = (0,stores/* useTypedSelector */.ix)(function(state) {
        return state.account;
    }), session = ref.session, loginState = ref.loginState, loginProcessing = ref.loginProcessing;
    var ref1 = (0,dist/* useAccount */.mA)(), address = ref1.address, _isConnected = ref1.isConnected, status = ref1.status;
    var ref2 = (0,react.useState)(false), needTrack = ref2[0], setNeedTrack = ref2[1];
    var ref3 = (0,react.useState)(undefined), isWalletQualified = ref3[0], setWalletQualified = ref3[1];
    var ref4 = useVerifyCampaign("account"), changeVerifyState = ref4.changeVerifyState, result = ref4.result, form = ref4.form;
    var login = (0,hooks_useAccount/* default */.Z)().login;
    var isConnected = _isConnected && available && status === "connected";
    var signed = isConnected && !!session;
    var showSignError = needVerify && !result.account;
    (0,react.useEffect)(function() {
        changeVerifyState(!!signed);
    }, [
        signed
    ]);
    (0,react.useEffect)(function() {
        if (needTrack && isConnected && (!holding || !holding.values.amount)) {
            mixpanel_cjs_default().track("connect_wallet", {
                is_wallet_qualified: true
            });
        } else if (needTrack && isConnected && holding && typeof isWalletQualified !== "undefined") {
            mixpanel_cjs_default().track("connect_wallet", {
                is_wallet_qualified: isWalletQualified
            });
        }
    }, [
        needTrack,
        isConnected,
        isWalletQualified,
        holding
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: available ? "" : "relative opacity-40 disable",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* WalletIcon */.o, {
                                        className: "dark:fill-[#87B5FF]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-body text-dark1 font-bold ml-2 dark:text-[#F9F9F9]",
                                        children: "Wallet"
                                    }),
                                    showSignError && !address && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-error text-sm ml-2",
                                        children: "This is required"
                                    }),
                                    address && isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-bodyS text-gray_58 ml-2 dark:text-[#B3D4F8]",
                                        children: (0,format/* trimAddr */.nM)(address)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-1"
                                    }),
                                    isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-green text-bodyS font-bold dark:text-dark_green",
                                        children: "Connected"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-bodyS text-dark1 mt-2 dark:text-[#DCECFA]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Connect and sign with your wallet."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Signing is safe and no transactions will be initiated."
                                    })
                                ]
                            })
                        ]
                    }),
                    !isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-shrink-0 ml-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            loading: loginProcessing,
                            onClick: function() {
                                login();
                                setNeedTrack(true);
                            },
                            variant: "outline",
                            radius: "xl",
                            size: "md",
                            children: "Connect"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2 py-2 px-4 bg-gray_f9 rounded-lg flex items-center justify-between ".concat(isConnected ? "" : "hidden", " dark:bg-[#192844] ").concat(showSignError ? "bg-error/10 border border-error" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-body text-dark1 dark:text-[#F9F9F9]",
                        children: "Sign your wallet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            !signed && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: login,
                                className: "mr-2 text-primary text-body font-bold action dark:text-[#6BB5FF]",
                                children: "Sign again"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckIcon */.nQ, {
                                className: "".concat(signed ? "fill-green dark:fill-dark_green text-black" : "")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-error text-sm mt-1 ".concat(showSignError && address ? "flex" : "hidden"),
                children: "This is required"
            }),
            holding && isConnected && holding.values.amount ? /*#__PURE__*/ (0,jsx_runtime.jsx)(campaign_TokenBalanceVerify, {
                verify: holding,
                setWalletQualified: setWalletQualified,
                needVerify: needVerify
            }) : null
        ]
    });
};
/* harmony default export */ var campaign_WalletVerify = (WalletVerify);

// EXTERNAL MODULE: ./src/form/hooks/useUserTwitter.tsx + 1 modules
var useUserTwitter = __webpack_require__(53969);
// EXTERNAL MODULE: ./src/form/services/modal.tsx
var modal = __webpack_require__(33799);
;// CONCATENATED MODULE: ./src/form/components/campaign/TwitterVerify.tsx











var TwitterVerify = function(param) {
    var form = param.form, available = param.available, needVerify = param.needVerify, submitError = param.submitError;
    var ref, ref1;
    var ref2 = (0,hooks_useAccount/* default */.Z)(), login = ref2.login, isLogin = ref2.isLogin;
    var ref3 = (0,useUserTwitter/* default */.Z)(), twitter = ref3.twitter, connect = ref3.connect, connecting = ref3.connecting, authLink = ref3.authLink, disconnect = ref3.disconnect;
    var ref4 = useVerifyCampaign("twitter"), changeVerifyState = ref4.changeVerifyState, result = ref4.result;
    var showConnectError = needVerify && !result.twitter;
    // const {changeVerifyState: changeFollowVerifyState} = useVerifyCampaign(`twitter_follow`);
    // const {changeVerifyState: changeLikeVerifyState} = useVerifyCampaign(`twitter_like`);
    // const {changeVerifyState: changeRetweetVerifyState} = useVerifyCampaign(`twitter_retweet`);
    // const {accountVerified, likeLinkVerified, retweetLinkVerified} = useTwitterVerify(form, twitter);
    // console.log(accountVerified, likeLinkVerified, retweetLinkVerified)
    var isConnected = !!twitter && available;
    (0,react.useEffect)(function() {
        changeVerifyState(isConnected);
    }, [
        isConnected
    ]);
    // useEffect(() => {
    //   changeFollowVerifyState(!form.values.needFollow || accountVerified);
    // }, [accountVerified, form.values.needFollow])
    // useEffect(() => {
    //   changeLikeVerifyState(!form.values.needLike || likeLinkVerified);
    // }, [likeLinkVerified, form.values.needLike])
    // useEffect(() => {
    //   changeRetweetVerifyState(!form.values.needRetweet || retweetLinkVerified);
    // }, [retweetLinkVerified, form.values.needRetweet])
    var verifyCount = 0;
    if (form.values.needFollow && form.values.accounts) {
        verifyCount += form.values.accounts.length;
    }
    if (form.values.needRetweet && form.values.retweetLink) {
        verifyCount++;
    }
    if (form.values.needLike && form.values.likeLink) {
        verifyCount++;
    }
    var showRetweetError = !!(submitError === null || submitError === void 0 ? void 0 : (ref = submitError[form.values.uid]) === null || ref === void 0 ? void 0 : ref.needRetweet);
    var showLikeError = !!(submitError === null || submitError === void 0 ? void 0 : (ref1 = submitError[form.values.uid]) === null || ref1 === void 0 ? void 0 : ref1.needLike);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: available ? "" : "relative opacity-40 disable",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                form.module.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(form.module.icon, {
                                    className: "fill-[#78C6F5] w-5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-body text-dark1 font-bold ml-2 dark:text-gray_f9",
                                    children: "Twitter"
                                }),
                                showConnectError && !twitter && !isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-error text-sm ml-2",
                                    children: "This is required"
                                }),
                                twitter && isConnected && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "px-2 py-1 flex items-center rounded-[35px] text-bodyS text-gray_58 ml-2 dark:text-[#DCECFA]",
                                    style: {
                                        boxShadow: "2px 4px 16px rgba(0, 0, 0, 0.05)"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                "@",
                                                twitter.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "action ml-1 w-[14px] h-[14px] rounded-full bg-primary flex items-center justify-center",
                                            onClick: function() {
                                                (0,modal/* confirm */.i)({
                                                    title: "Are you sure to disconnect your account?",
                                                    okText: "Disconnect",
                                                    okType: "danger",
                                                    onOk: function onOk() {
                                                        disconnect();
                                                    }
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                                                className: "w-[6px]"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-1"
                                }),
                                isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-green text-bodyS font-bold dark:text-dark_green",
                                    children: "Connected"
                                })
                            ]
                        })
                    }),
                    !isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-shrink-0 ml-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            rel: "noreferrer",
                            href: authLink,
                            className: "block",
                            target: "_blank",
                            onClick: function(e) {
                                if (!isLogin) {
                                    login();
                                    e.preventDefault();
                                    return false;
                                }
                                if (!authLink) {
                                    e.preventDefault();
                                    return false;
                                }
                                mixpanel_cjs_default().track("connect_twitter");
                                connect();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                loading: connecting,
                                variant: "outline",
                                radius: "xl",
                                size: "md",
                                children: "Connect"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2 ".concat(isConnected ? "" : "hidden", " ").concat(verifyCount > 1 ? "grid grid-cols-2 gap-2 " : ""),
                children: [
                    form.values.needFollow && form.values.accounts && form.values.accounts.map(function(account, index) {
                        var ref;
                        var followError = (submitError === null || submitError === void 0 ? void 0 : (ref = submitError[form.values.uid]) === null || ref === void 0 ? void 0 : ref.needFollow) || [];
                        var showError = followError.includes(account);
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "py-2 px-4 bg-gray_f9 rounded-lg flex items-center justify-between dark:bg-[#192844] ".concat(showError ? "bg-error/10 border border-error" : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center text-body text-dark1 flex-1 overflow-hidden dark:text-gray_f9",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "flex-shrink-0",
                                                children: "Follow"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                passHref: true,
                                                href: (0,format/* twitterUserLink */.tq)(account),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: "text-[#47679A] underline mx-1 text-ellipsis overflow-hidden dark:text-[#87B5FF]",
                                                    target: "_black",
                                                    children: [
                                                        "@",
                                                        account
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "flex-shrink-0",
                                                children: "on Twitter"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-error text-sm mt-1 ".concat(showError ? "flex" : "hidden"),
                                    children: "This is required"
                                })
                            ]
                        }, index);
                    }),
                    form.values.needLike && form.values.likeLink && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-2 px-4 bg-gray_f9 rounded-lg flex items-center justify-between dark:bg-[#192844] ".concat(showLikeError ? "bg-error/10 border border-error" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center text-body text-dark1 dark:text-gray_f9",
                                    children: [
                                        "Like this",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            passHref: true,
                                            href: form.values.likeLink,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-[#47679A] underline mx-1 dark:text-[#87B5FF]",
                                                target: "_black",
                                                children: "tweet"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-error text-sm mt-1 ".concat(showLikeError ? "flex" : "hidden"),
                                children: "This is required"
                            })
                        ]
                    }),
                    form.values.needRetweet && form.values.retweetLink && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-2 px-4 bg-gray_f9 rounded-lg flex items-center justify-between dark:bg-[#192844] ".concat(showRetweetError ? "bg-error/10 border border-error" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center text-body text-dark1 dark:text-gray_f9",
                                    children: [
                                        "Retweet this",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            passHref: true,
                                            href: form.values.retweetLink,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-[#47679A] underline mx-1 dark:text-[#87B5FF]",
                                                target: "_black",
                                                children: "tweet"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-error text-sm mt-1 ".concat(showRetweetError ? "flex" : "hidden"),
                                children: "This is required"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var campaign_TwitterVerify = (TwitterVerify);

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Loader/Loader.js + 3 modules
var Loader = __webpack_require__(76080);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(80061);
// EXTERNAL MODULE: ./src/form/hooks/useUserEmail.tsx
var useUserEmail = __webpack_require__(80541);
// EXTERNAL MODULE: ./src/form/utils/validate.ts
var validate = __webpack_require__(65746);
// EXTERNAL MODULE: ./src/form/services/account.ts
var account = __webpack_require__(86748);
;// CONCATENATED MODULE: ./src/form/components/campaign/EmailVerify.tsx














var EmailVerify = function(param) {
    var form = param.form, available = param.available, needFormVerify = param.needFormVerify, submitError = param.submitError;
    var ref;
    var userInfo = (0,stores/* useTypedSelector */.ix)(function(state) {
        return state.account.userInfo;
    });
    var ref1 = (0,hooks_useAccount/* default */.Z)(), isLogin = ref1.isLogin, login = ref1.login;
    var needVerify = form.values.verifyEmail && available;
    var ref2 = (0,useUserEmail/* default */.Z)(needVerify), email = ref2.email, setEmail = ref2.setEmail, verify = ref2.verify, sent = ref2.sent, verifying = ref2.verifying, onceSend = ref2.onceSend;
    var isEmailValid = (0,validate/* validateEmail */.oH)(email);
    var isEmailVerified = !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.is_email_verified);
    var ref3 = useVerifyCampaign("email"), changeVerifyState = ref3.changeVerifyState, changeForm = ref3.changeForm, userForm = ref3.form, result = ref3.result;
    var serverError = submitError === null || submitError === void 0 ? void 0 : (ref = submitError[form.values.uid]) === null || ref === void 0 ? void 0 : ref.verifyEmail;
    var showError = needFormVerify && !result.email || serverError;
    (0,react.useEffect)(function() {
        if (!isEmailValid) {
            return changeVerifyState(false);
        }
        if (needVerify && !isEmailVerified) {
            return changeVerifyState(false);
        }
        changeVerifyState(true);
    }, [
        needVerify,
        isEmailVerified,
        isEmailValid
    ]);
    var rightSection = null;
    (0,react.useEffect)(function() {
        changeForm(email);
    }, [
        email
    ]);
    var disconnect = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!isEmailVerified) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,account/* revokeEmail */.px)()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        isEmailVerified
    ]);
    var sendEmail = (0,react.useCallback)(function() {
        if (!isEmailValid) {
            return;
        }
        if (!isLogin) {
            return login();
        }
        mixpanel_cjs_default().track("verify_email");
        verify();
    }, [
        isLogin,
        verify,
        isEmailValid
    ]);
    if (needVerify && !isEmailVerified) {
        if (verifying && !sent) {
            rightSection = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-end w-full pr-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    size: "xs"
                })
            });
        } else if (sent) {
            rightSection = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-body font-bold text-gray_95 text-right w-full pr-3",
                children: "Sent"
            });
        } else if (onceSend) {
            rightSection = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-body font-bold text-primary action text-right  w-full pr-3 ".concat(isEmailValid ? "" : "opacity-50 hover:cursor-not-allowed"),
                onClick: sendEmail,
                children: "Re-send"
            });
        } else {
            rightSection = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-body font-bold text-primary action text-right ".concat(isEmailValid ? "" : "opacity-50 hover:cursor-not-allowed"),
                onClick: sendEmail,
                children: "Send verification"
            });
        }
    } else {
        rightSection = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "action translate-x-[38px] ml-1 w-[14px] h-[14px] rounded-full bg-primary flex items-center justify-center",
            onClick: function() {
                (0,modal/* confirm */.i)({
                    title: "Are you sure to disconnect your account?",
                    okText: "Disconnect",
                    okType: "danger",
                    onOk: function onOk() {
                        disconnect();
                    }
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                className: "w-[6px]"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: available ? "" : "relative opacity-40 disable",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            form.module.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(form.module.icon, {
                                className: "dark:fill-[#3C86FB]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-body text-dark1 font-bold ml-2 dark:text-gray_f9",
                                children: "Email"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                readOnly: needVerify && isEmailVerified || verifying && !sent,
                value: available ? email : "",
                className: "mt-2",
                size: "md",
                classNames: {
                    input: "border-[#e7e7e7] dark:!bg-[#192844] dark:border-[#2F5EAA] dark:text-gray_f9 ".concat(showError ? "bg-error/10 border border-error" : "")
                },
                placeholder: "Your email",
                rightSectionWidth: 130,
                rightSection: rightSection,
                disabled: !!userForm.id,
                onChange: function(e) {
                    setEmail(e.currentTarget.value);
                }
            }),
            needVerify && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "py-2 px-4 bg-gray_f9 rounded-lg flex items-center justify-between dark:bg-[#192844] ".concat(showError ? "bg-error/10 border border-error" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center text-body text-dark1 dark:text-gray_f9",
                                children: "Verify your email"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckIcon */.nQ, {
                                className: isEmailVerified ? "fill-green dark:fill-dark_green" : "dark:fill-[#94949C]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-error text-sm mt-1 ".concat(showError && !isEmailVerified ? "flex" : "hidden"),
                        children: "This is required"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-error text-sm mt-1 ".concat(showError ? "flex" : "hidden"),
                children: "This is required"
            })
        ]
    });
};
/* harmony default export */ var campaign_EmailVerify = (EmailVerify);

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Textarea/Textarea.js + 4 modules
var Textarea = __webpack_require__(67288);
;// CONCATENATED MODULE: ./src/form/components/campaign/QuestionVerify.tsx






var QuestionVerify = function(param) {
    var quesion = param.quesion, available = param.available, needVerify = param.needVerify;
    var ref, ref1;
    var ref2 = useVerifyCampaign("question"), changeVerifyState = ref2.changeVerifyState, changeForm = ref2.changeForm, form = ref2.form, result = ref2.result;
    var ref3 = (0,react.useState)(false), tracked = ref3[0], setTracked = ref3[1];
    var showError = needVerify && !result.question;
    (0,react.useEffect)(function() {
        changeVerifyState(!!form.question);
    }, [
        form.question
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: available ? "" : "relative opacity-40 disable",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* QuestionIcon */.UO, {
                                    className: "dark:fill-[#3C86FB]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ml-2 font-bold text-body text-dark1 dark:text-gray_f9",
                                    children: "Question"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-3 text-bodyS text-dark1 dark:text-gray_f9",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: quesion === null || quesion === void 0 ? void 0 : (ref = quesion.values) === null || ref === void 0 ? void 0 : ref.question
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea/* Textarea */.g, {
                        readOnly: !available,
                        value: form.question,
                        className: "mt-2",
                        size: "md",
                        classNames: {
                            input: "border-[#e7e7e7] dark:!bg-[#192844] dark:border-[#2F5EAA] ".concat(showError ? "bg-error/10 border border-error" : "")
                        },
                        styles: {
                            input: {
                                minHeight: 75,
                                paddingBottom: "30px!important"
                            }
                        },
                        disabled: !!form.id,
                        maxLength: 500,
                        autosize: true,
                        onChange: function(e) {
                            changeForm(e.currentTarget.value);
                            if (!tracked) {
                                setTracked(true);
                                mixpanel_cjs_default().track("input_answer");
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute right-5 bottom-3 text-bodyS dark:text-gray_f9",
                        children: [
                            (form === null || form === void 0 ? void 0 : (ref1 = form.question) === null || ref1 === void 0 ? void 0 : ref1.length) || 0,
                            "/500"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-error text-sm mt-1 ".concat(showError ? "flex" : "hidden"),
                children: "This is required"
            })
        ]
    });
};
/* harmony default export */ var campaign_QuestionVerify = (QuestionVerify);

// EXTERNAL MODULE: ./src/form/hooks/useUserDiscord.ts + 1 modules
var useUserDiscord = __webpack_require__(78867);
;// CONCATENATED MODULE: ./src/form/components/campaign/DiscordVerify.tsx










var DiscordVerify = function(param) {
    var form = param.form, available = param.available, needVerify = param.needVerify, submitError = param.submitError;
    var ref = (0,hooks_useAccount/* default */.Z)(), login = ref.login, isLogin = ref.isLogin;
    var ref1 = (0,useUserDiscord/* default */.Z)(), discord = ref1.discord, connect = ref1.connect, connecting = ref1.connecting, authLink = ref1.authLink, disconnect = ref1.disconnect;
    var ref2 = useVerifyCampaign("discord"), changeVerifyState = ref2.changeVerifyState, result = ref2.result;
    var isConnected = isLogin && !!discord && available;
    var showConnectError = needVerify && !result.discord;
    (0,react.useEffect)(function() {
        changeVerifyState(isConnected);
    }, [
        isConnected
    ]);
    var verifyCount = 0;
    if (form.values.needFollowChannel && form.values.channel) {
        verifyCount++;
    }
    if (form.values.needJoinServer && form.values.serverLinks) {
        verifyCount += form.values.serverLinks.length;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: available ? "" : "relative opacity-40 disable",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                form.module.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(form.module.icon, {
                                    className: "w-5 h-5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-body text-dark1 font-bold ml-2 dark:text-gray_f9",
                                    children: "Discord"
                                }),
                                showConnectError && !discord && !isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-error text-sm ml-2",
                                    children: "This is required"
                                }),
                                discord && isConnected && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "px-2 py-1 flex items-center rounded-[35px] text-bodyS text-gray_58 ml-2 dark:text-[#DCECFA]",
                                    style: {
                                        boxShadow: "2px 4px 16px rgba(0, 0, 0, 0.05)"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                "@",
                                                (discord === null || discord === void 0 ? void 0 : discord.global_name) || discord.username
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "action ml-1 w-[14px] h-[14px] rounded-full bg-primary flex items-center justify-center",
                                            onClick: function() {
                                                (0,modal/* confirm */.i)({
                                                    title: "Are you sure to disconnect your account?",
                                                    okText: "Disconnect",
                                                    okType: "danger",
                                                    onOk: function onOk() {
                                                        disconnect();
                                                    }
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                                                className: "w-[6px]"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-1"
                                }),
                                isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-green text-bodyS font-bold dark:text-dark_green",
                                    children: "Connected"
                                })
                            ]
                        })
                    }),
                    !isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-shrink-0 ml-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: authLink,
                            rel: "noreferrer",
                            className: "block",
                            target: "_blank",
                            onClick: function(e) {
                                if (!isLogin) {
                                    login();
                                    e.preventDefault();
                                    return false;
                                }
                                if (!authLink) {
                                    e.preventDefault();
                                    return false;
                                }
                                mixpanel_cjs_default().track("connect_discord");
                                connect();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                loading: connecting,
                                variant: "outline",
                                radius: "xl",
                                size: "md",
                                children: "Connect"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2 ".concat(isConnected ? "" : "hidden", " ").concat(verifyCount > 1 ? "grid grid-cols-2 gap-2 " : ""),
                children: [
                    form.values.needJoinServer && form.values.serverLinks && form.values.serverLinks.map(function(serverLink, index) {
                        var ref;
                        var joinError = (submitError === null || submitError === void 0 ? void 0 : (ref = submitError[form.values.uid]) === null || ref === void 0 ? void 0 : ref.needJoinServer) || [];
                        var showError = joinError.includes(serverLink);
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "py-2 px-4 bg-gray_f9 rounded-lg flex items-center justify-between dark:bg-[#192844] ".concat(showError ? "bg-error/10 border border-error" : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center text-body text-dark1 flex-1 flex-wrap dark:text-gray_f9",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "flex-shrink-0",
                                                children: "Join this"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                passHref: true,
                                                href: serverLink,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "text-[#47679A] underline mx-1 flex-1 text-ellipsis overflow-hidden dark:text-[#87B5FF]",
                                                    target: "_black",
                                                    children: "server"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-error text-sm mt-1 ".concat(showError ? "flex" : "hidden"),
                                    children: "This is required"
                                })
                            ]
                        }, index);
                    }),
                    form.values.needFollowChannel && form.values.channel && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-2 px-4 bg-gray_f9 rounded-lg flex items-center justify-between dark:bg-[#192844]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center text-body text-dark1 dark:text-gray_f9",
                            children: [
                                "Join this",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    passHref: true,
                                    href: form.values.channel,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-[#47679A] underline mx-1 dark:text-[#87B5FF]",
                                        target: "_black",
                                        children: "channel"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var campaign_DiscordVerify = (DiscordVerify);

;// CONCATENATED MODULE: ./src/form/components/campaign/SourceTrack.tsx



var SourceTrack = function() {
    var router = (0,next_router.useRouter)();
    var ref = useVerifyCampaign("source"), changeVerifyState = ref.changeVerifyState, changeForm = ref.changeForm, form = ref.form;
    (0,react.useEffect)(function() {
        changeVerifyState(true);
        changeForm(router.query.source);
    }, [
        router
    ]);
    return null;
};
/* harmony default export */ var campaign_SourceTrack = (SourceTrack);

;// CONCATENATED MODULE: ./src/form/services/sendingme.ts



var getAuthLink = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request/* default.rpc */.Z.rpc("sendingme/authlink", {})
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getAuthLink() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/form/hooks/useUserSendingme.tsx







function useUserSendingme() {
    var ref = (0,react.useState)(null), sendingme = ref[0], setSendingme = ref[1];
    var ref1 = (0,react.useState)(false), connecting = ref1[0], setConnecting = ref1[1];
    var ref2 = (0,react.useState)(""), error = ref2[0], setError = ref2[1];
    var ref3 = (0,hooks_useAccount/* default */.Z)(), login = ref3.login, isLogin = ref3.isLogin;
    var ref4 = (0,react.useState)(""), authLink = ref4[0], setAuthLink = ref4[1];
    var userInfo = (0,stores/* useTypedSelector */.ix)(function(state) {
        return state.account.userInfo;
    });
    (0,react.useEffect)(function() {
        if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.discord) {
            setSendingme(userInfo.sendingme);
            setConnecting(false);
            setError("");
        } else {
            setSendingme(null);
            setConnecting(false);
            setError("");
        }
    }, [
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.sendingme
    ]);
    (0,react.useEffect)(function() {
        if (userInfo && !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.sendingme) && isLogin) {
            getAuthLink().then(function(res) {
                setAuthLink(res.authLink);
            });
        }
    }, [
        isLogin,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.sendingme
    ]);
    (0,react.useEffect)(function() {
        if (connecting) {
            var timer = setTimeout(function() {
                setConnecting(false);
            }, 5000);
            return function() {
                clearTimeout(timer);
            };
        }
    }, [
        connecting
    ]);
    var connect = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (!userInfo) {
                return [
                    2,
                    login()
                ];
            }
            if (userInfo.sendingme) {
                return [
                    2
                ];
            }
            setConnecting(true);
            return [
                2
            ];
        });
    }), [
        userInfo,
        login
    ]);
    (0,react.useEffect)(function() {
        if (error) {
            react_toastify_esm/* toast.error */.Am.error(error);
            setError("");
        }
    }, [
        error
    ]);
    return {
        sendingme: sendingme,
        connecting: connecting,
        error: error,
        connect: connect,
        authLink: authLink
    };
}

;// CONCATENATED MODULE: ./src/form/components/campaign/SendingmeVerify.tsx








var SendingmeVerify = function(param) {
    var form = param.form, available = param.available, needVerify = param.needVerify, submitError = param.submitError;
    var ref = (0,hooks_useAccount/* default */.Z)(), login = ref.login, isLogin = ref.isLogin;
    var ref1 = useUserSendingme(), sendingme = ref1.sendingme, connect = ref1.connect, connecting = ref1.connecting, authLink = ref1.authLink;
    var ref2 = useVerifyCampaign("sendingme"), changeVerifyState = ref2.changeVerifyState, result = ref2.result;
    var isConnected = isLogin && !!sendingme && available;
    var showConnectError = needVerify && !result.sendingme;
    (0,react.useEffect)(function() {
        changeVerifyState(isConnected);
    }, [
        isConnected
    ]);
    var verifyCount = 0;
    if (form.values.needJoinSquad && form.values.squads) {
        verifyCount++;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: available ? "" : "relative opacity-40 disable",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                form.module.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(form.module.icon, {
                                    className: "w-5 h-5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-body text-dark1 font-bold ml-2 dark:text-gray_f9",
                                    children: "Sending.Me"
                                }),
                                showConnectError && !sendingme && !isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-error text-sm ml-2",
                                    children: "This is required"
                                }),
                                sendingme && isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-bodyS text-gray_58 ml-2 dark:text-[#DCECFA]",
                                    children: "@"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-1"
                                }),
                                isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-green text-bodyS font-bold dark:text-dark_green",
                                    children: "Connected"
                                })
                            ]
                        })
                    }),
                    !isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-shrink-0 ml-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: authLink,
                            rel: "noreferrer",
                            className: "block",
                            target: "_blank",
                            onClick: function(e) {
                                if (!isLogin) {
                                    login();
                                    e.preventDefault();
                                    return false;
                                }
                                if (!authLink) {
                                    e.preventDefault();
                                    return false;
                                }
                                mixpanel_cjs_default().track("connect_sendingme");
                                connect();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                loading: connecting,
                                variant: "outline",
                                radius: "xl",
                                size: "md",
                                children: "Connect"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 ".concat(isConnected ? "" : "hidden", " ").concat(verifyCount > 1 ? "grid grid-cols-2 gap-2 " : ""),
                children: form.values.needJoinSquad && form.values.squads && form.values.squads.map(function(squad, index) {
                    var ref;
                    var joinError = (submitError === null || submitError === void 0 ? void 0 : (ref = submitError[form.values.uid]) === null || ref === void 0 ? void 0 : ref.needJoinSquad) || [];
                    var showError = joinError.includes(squad);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-2 px-4 bg-gray_f9 rounded-lg flex items-center justify-between dark:bg-[#192844] ".concat(showError ? "bg-error/10 border border-error" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center text-body text-dark1 flex-1 flex-wrap dark:text-gray_f9",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "flex-shrink-0",
                                            children: "Join this"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            passHref: true,
                                            href: squad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-[#47679A] underline mx-1 flex-1 text-ellipsis overflow-hidden dark:text-[#87B5FF]",
                                                target: "_black",
                                                children: "squad"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-error text-sm mt-1 ".concat(showError ? "flex" : "hidden"),
                                children: "This is required"
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var campaign_SendingmeVerify = (SendingmeVerify);

;// CONCATENATED MODULE: ./src/form/components/campaign/Editor.tsx





























var CampaignEditor = function(param) {
    var embed = param.embed;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
    var router = (0,next_router.useRouter)();
    var ref33 = useVerifyCampaign(), verified = ref33.verified, submit = ref33.submit, submiting = ref33.submiting, userForm = ref33.form, submitError = ref33.submitError;
    var ref34 = (0,react.useState)(false), showRedirect = ref34[0], setShowRedirect = ref34[1];
    var ref35 = (0,hooks_useAccount/* default */.Z)(), address = ref35.address, isLogin = ref35.isLogin;
    var ref36 = (0,useForm/* default */.Z)(router.query.id), localForm = ref36.form, localError = ref36.error;
    var activeVerify = (0,stores/* useTypedSelector */.ix)(function(state) {
        return {
            activeVerify: state.campaignVerify.activeVerify
        };
    }).activeVerify;
    var activeFrom = localForm;
    var activeError = localError;
    var ref37 = useCampaignResponseStatus(router.query.id), status = ref37.status, setStatus = ref37.setStatus;
    var viewMode = router.query.mode || "default";
    var ref38 = (0,react.useState)(false), successOpened = ref38[0], setSuccessOpened = ref38[1];
    var needVerify = activeVerify === (activeFrom === null || activeFrom === void 0 ? void 0 : activeFrom.id);
    (0,react.useEffect)(function() {
        if (isLogin) {
            var timer = setInterval(function() {
                stores/* default.dispatch */.ZP.dispatch(stores/* actions.account.fetchUserInfo */.Nw.account.fetchUserInfo());
            }, 3000);
            return function() {
                clearInterval(timer);
            };
        }
    }, [
        isLogin
    ]);
    (0,react.useEffect)(function() {
        if (router.query.theme === "dark") {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
        return function() {
            document.documentElement.classList.remove("dark");
        };
    }, [
        router
    ]);
    var blocks = (0,modules/* formBlockMap */.fx)(activeFrom);
    var needRedirect = !!(blocks === null || blocks === void 0 ? void 0 : blocks.redirect);
    var showInfoBlock = !!(blocks === null || blocks === void 0 ? void 0 : blocks.max_entries) || !!(blocks === null || blocks === void 0 ? void 0 : blocks.website) || !!(blocks === null || blocks === void 0 ? void 0 : blocks.event_date) || !!(blocks === null || blocks === void 0 ? void 0 : blocks.location);
    var isPreview = router.route === "/forms/preview";
    var sectionClass = "pb-6 mb-6 border-b border-b-gray_f3 last:pb-0 last:mb-0 last:border-none dark:border-b-[#192844]";
    var navBack = (0,react.useCallback)(function() {
        router.back();
    }, []);
    var onSubmit = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var blocks, res;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(activeFrom === null || activeFrom === void 0 ? void 0 : activeFrom.id)) {
                        return [
                            2
                        ];
                    }
                    stores/* default.dispatch */.ZP.dispatch(stores/* actions.campaignVerify.setActiveVerifyForm */.Nw.campaignVerify.setActiveVerifyForm(activeFrom.id));
                    if (!verified) {
                        return [
                            2
                        ];
                    }
                    blocks = (0,modules/* formBlockMap */.fx)(activeFrom);
                    console.log("userForm", userForm);
                    return [
                        4,
                        submit({
                            campaign_id: activeFrom.id,
                            context: userForm,
                            campaign_name: blocks === null || blocks === void 0 ? void 0 : blocks.title.values.title
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res) {
                        setStatus(res);
                        stores/* default.dispatch */.ZP.dispatch(stores/* actions.campaignVerify.changeForm */.Nw.campaignVerify.changeForm({
                            field: "id",
                            value: res.id
                        }));
                        setSuccessOpened(true);
                        if (needRedirect) {
                            setShowRedirect(true);
                        }
                        if (embed && window.parent) {
                            window.parent.postMessage({
                                type: "submit",
                                data: {
                                    context: userForm,
                                    user_address: address,
                                    id: activeFrom.id
                                }
                            }, "*");
                        }
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        activeFrom,
        userForm,
        needRedirect,
        embed,
        verified
    ]);
    useEditMessage({
        blocks: blocks,
        status: status
    });
    var campaginNotAvaliable = activeFrom ? !(0,campaign/* checkCampaignAvailable */.yT)(activeFrom) : false;
    var tdk = (0,_object_spread/* default */.Z)({}, config/* TDK */._T);
    if (blocks === null || blocks === void 0 ? void 0 : (ref = blocks.title) === null || ref === void 0 ? void 0 : (ref1 = ref.values) === null || ref1 === void 0 ? void 0 : ref1.title) {
        var ref39, ref40;
        tdk.title = blocks === null || blocks === void 0 ? void 0 : (ref39 = blocks.title) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.values) === null || ref40 === void 0 ? void 0 : ref40.title;
    }
    if (blocks === null || blocks === void 0 ? void 0 : (ref2 = blocks.description) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.values) === null || ref3 === void 0 ? void 0 : ref3.description) {
        var ref41, ref42;
        tdk.description = blocks === null || blocks === void 0 ? void 0 : (ref41 = blocks.description) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.values) === null || ref42 === void 0 ? void 0 : ref42.description;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* default */.Z, {
                tdk: tdk
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mb-8 ".concat(campaginNotAvaliable ? "" : "hidden", " mt-8 sm:mt-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-header text-dark1 font-bold text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "This form is currently closed. "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Contact form owner for additional information."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mb-8 ".concat(activeError ? "" : "hidden", " mt-8 sm:mt-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-header text-dark1 font-bold text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: activeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Contact form owner for additional information."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(isPreview ? "" : "hidden", " flex items-center justify-between py-2 px-7 mb-4 shadow-[0px_4px_4px_rgba(0,0,0,0.1)] bg-white rounded-lg"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeIcon */.tE, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ml-2 text-headerL font-bold text-dark1",
                                children: "Preview mode"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center text-primary font-bold text-header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "action",
                            onClick: navBack,
                            children: "Exit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(embed ? "w-full bg-white e-form:pr-0 e-form:h-[80vh] e-form:max-h-[833px] e-form:flex" : "bg-white s-form:shadow-[15px_4px_100px_rgba(0,0,0,0.1)] s-form:rounded-lg s-form:p-10 s-form:pr-0 s-form:h-[80vh] s-form:max-h-[833px] s-form:flex", "  p-4  transition-all  ").concat(!blocks ? "blur-sm" : "", " pb-20 sm:pb-0 ").concat(viewMode === "s" ? "s-form:max-h-full w-full bg-transparent" : "", " dark:bg-[#151C2B]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(campaginNotAvaliable ? "bg-gray_f9" : "bg-primary/80", " ").concat(embed ? "e-form:w-full e-form:mr-10 flex-1" : "s-form:w-[400px] s-form:mr-10", " max-h-[608px] py-14 px-10 rounded-lg  flex-shrink-0  flex flex-col ").concat(viewMode === "s" ? "hidden" : "", " dark:bg-[#1D283C]"),
                        children: [
                            (blocks === null || blocks === void 0 ? void 0 : (ref4 = blocks.reward) === null || ref4 === void 0 ? void 0 : ref4.values.type) && (blocks === null || blocks === void 0 ? void 0 : (ref5 = blocks.reward) === null || ref5 === void 0 ? void 0 : ref5.values.type) !== "empty" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-shrink-0 w-[103px] py-3 mb-5 bg-[#FFE767] text-bodyS font-bold text-dark1 rounded-sm text-center relative dark:bg-[#FFD0AD]",
                                children: [
                                    (ref7 = blocks === null || blocks === void 0 ? void 0 : (ref6 = blocks.reward) === null || ref6 === void 0 ? void 0 : ref6.rewardName()) === null || ref7 === void 0 ? void 0 : ref7.toUpperCase(),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GiftIcon */.Og, {
                                        className: "absolute -left-1 -top-1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* StarIcon */.r7, {
                                        className: "w-2 h-2 absolute left-1 bottom-1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* StarIcon */.r7, {
                                        className: "absolute left-4 bottom-3 fill-[#FFD600]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* StarIcon */.r7, {
                                        className: "absolute right-4 top-1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* StarIcon */.r7, {
                                        className: "w-2 h-2 absolute right-1 top-2 fill-[#FFD600] rotate-12"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-shrink-0 text-2xl font-bold ".concat(campaginNotAvaliable ? "text-dark1" : "text-white", " mb-7"),
                                children: blocks === null || blocks === void 0 ? void 0 : (ref8 = blocks.title) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.values) === null || ref9 === void 0 ? void 0 : ref9.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-shrink-0  ".concat(campaginNotAvaliable ? "bg-gray_f0 text-dark1" : "bg-[#5194FF] text-white", " mb-7 p-4 rounded-lg text-bodyS font-bold ").concat(showInfoBlock ? "block" : "hidden", " dark:bg-[#161E30]"),
                                children: [
                                    (blocks === null || blocks === void 0 ? void 0 : (ref10 = blocks.max_entries) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.module) === null || ref11 === void 0 ? void 0 : ref11.icon) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center mb-2 last:mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(blocks.max_entries.module.icon, {
                                                className: "w-4 h-4 mr-3 ".concat(campaginNotAvaliable ? "fill-dark1" : "")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    blocks.max_entries.values.amount,
                                                    " Entries "
                                                ]
                                            })
                                        ]
                                    }),
                                    (blocks === null || blocks === void 0 ? void 0 : (ref12 = blocks.website) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.module) === null || ref13 === void 0 ? void 0 : ref13.icon) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center mb-2 last:mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(blocks.website.module.icon, {
                                                className: "w-4 h-4 mr-3 flex-shrink-0 ".concat(campaginNotAvaliable ? "fill-dark1" : "")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: blocks.website.values.link,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "action flex-1 overflow-hidden text-ellipsis whitespace-nowrap",
                                                    target: "_blank",
                                                    "data-track": "click_website",
                                                    "data-track-params": '{"form_id": "'.concat(router.query.id, '"}'),
                                                    children: blocks.website.values.link
                                                })
                                            })
                                        ]
                                    }),
                                    (blocks === null || blocks === void 0 ? void 0 : (ref14 = blocks.event_date) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.module) === null || ref15 === void 0 ? void 0 : ref15.icon) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center mb-2 last:mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(blocks.event_date.module.icon, {
                                                className: "w-4 h-4 mr-3 ".concat(campaginNotAvaliable ? "fill-dark1" : "")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: (0,format/* googleCalendarLink */.ny)({
                                                    title: blocks.title.values.title,
                                                    description: blocks.description.values.description,
                                                    location: (ref16 = blocks.location) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.values) === null || ref17 === void 0 ? void 0 : ref17.location,
                                                    start: new Date(blocks.event_date.values.start),
                                                    end: new Date(blocks.event_date.values.end)
                                                }),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "action",
                                                    target: "_blank",
                                                    children: blocks.event_date.dateDesc()
                                                })
                                            })
                                        ]
                                    }),
                                    (blocks === null || blocks === void 0 ? void 0 : (ref18 = blocks.location) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.module) === null || ref19 === void 0 ? void 0 : ref19.icon) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center mb-2 last:mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(blocks.location.module.icon, {
                                                className: "w-4 h-4 mr-3 flex-shrink-0 ".concat(campaginNotAvaliable ? "fill-dark1" : "")
                                            }),
                                            blocks.location.values.type === "online" && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: blocks.location.values.link,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    "data-track": "open_link",
                                                    "data-track-params": '{"form_id": "'.concat(router.query.id, '"}'),
                                                    className: "action flex-1 overflow-hidden text-ellipsis whitespace-nowrap",
                                                    target: "_blank",
                                                    children: blocks.location.values.link
                                                })
                                            }),
                                            blocks.location.values.type !== "online" && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: (0,format/* googleMapLink */.Ot)(blocks.location.values.location),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "action whitespace-pre-wrap",
                                                    target: "_blank",
                                                    "data-track": "open_link",
                                                    "data-track-params": '{"form_id": "'.concat(router.query.id, '"}'),
                                                    children: blocks.location.locationDesc()
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea */.x, {
                                className: "flex-1 text-bodyS ".concat(campaginNotAvaliable ? "text-dark1" : "text-gray_f3", "  whitespace-pre-wrap"),
                                scrollbarSize: 6,
                                styles: {
                                    scrollbar: {
                                        '&[data-orientation="vertical"] .mantine-ScrollArea-thumb': {
                                            backgroundColor: "#3C86FB"
                                        },
                                        "&, &:hover": {
                                            background: "#E9F1FF",
                                            borderRadius: "8px"
                                        }
                                    }
                                },
                                children: blocks === null || blocks === void 0 ? void 0 : (ref20 = blocks.description) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.values) === null || ref21 === void 0 ? void 0 : ref21.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "h-full flex flex-col flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollArea/* ScrollArea */.x, {
                                className: "flex-1 pt-10 pb-4 ".concat(embed ? "!overflow-visible e-form:!overflow-hidden e-form:pr-7 e-form:mr-3" : "s-form:pr-7 s-form:mr-3", " ").concat(viewMode === "s" ? "pt-0" : ""),
                                scrollbarSize: 6,
                                styles: {
                                    scrollbar: {
                                        '&[data-orientation="vertical"] .mantine-ScrollArea-thumb': {
                                            backgroundColor: "#3C86FB"
                                        },
                                        "&, &:hover": {
                                            background: "#E0E1E1",
                                            borderRadius: "8px"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: sectionClass,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(campaign_WalletVerify, {
                                            available: !campaginNotAvaliable,
                                            holding: blocks === null || blocks === void 0 ? void 0 : blocks.holding,
                                            needVerify: needVerify
                                        })
                                    }),
                                    (blocks === null || blocks === void 0 ? void 0 : (ref22 = blocks.twitter) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.module) === null || ref23 === void 0 ? void 0 : ref23.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: sectionClass,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(campaign_TwitterVerify, {
                                            available: !campaginNotAvaliable,
                                            form: blocks.twitter,
                                            needVerify: needVerify,
                                            submitError: submitError
                                        })
                                    }),
                                    (blocks === null || blocks === void 0 ? void 0 : (ref24 = blocks.discord) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.module) === null || ref25 === void 0 ? void 0 : ref25.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: sectionClass,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(campaign_DiscordVerify, {
                                            available: !campaginNotAvaliable,
                                            form: blocks.discord,
                                            needVerify: needVerify,
                                            submitError: submitError
                                        })
                                    }),
                                    (blocks === null || blocks === void 0 ? void 0 : (ref26 = blocks.sendingme) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.module) === null || ref27 === void 0 ? void 0 : ref27.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: sectionClass,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(campaign_SendingmeVerify, {
                                            available: !campaginNotAvaliable,
                                            form: blocks.sendingme,
                                            needVerify: needVerify,
                                            submitError: submitError
                                        })
                                    }),
                                    (blocks === null || blocks === void 0 ? void 0 : (ref28 = blocks.email) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.module) === null || ref29 === void 0 ? void 0 : ref29.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: sectionClass,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(campaign_EmailVerify, {
                                            available: !campaginNotAvaliable,
                                            form: blocks.email,
                                            needFormVerify: needVerify,
                                            submitError: submitError
                                        })
                                    }),
                                    (blocks === null || blocks === void 0 ? void 0 : (ref30 = blocks.question) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.module) === null || ref31 === void 0 ? void 0 : ref31.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: sectionClass,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(campaign_QuestionVerify, {
                                            available: !campaginNotAvaliable,
                                            quesion: blocks.question,
                                            needVerify: needVerify
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center mt-5",
                                children: status ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    classNames: {
                                        inner: "text-body w-[100px]",
                                        root: "w-[155px] opacity-30"
                                    },
                                    size: "md",
                                    radius: "xl",
                                    children: "Submited"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    classNames: {
                                        inner: "text-body w-[100px]",
                                        root: "w-[155px]"
                                    },
                                    size: "md",
                                    radius: "xl",
                                    loading: submiting,
                                    disabled: !campaginNotAvaliable ? isPreview || status : true,
                                    onClick: onSubmit,
                                    children: "Submit"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(campaign_SourceTrack, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(campaign_RedirectModal, {
                opened: showRedirect,
                setOpened: setShowRedirect,
                link: blocks === null || blocks === void 0 ? void 0 : (ref32 = blocks.redirect) === null || ref32 === void 0 ? void 0 : ref32.values.link
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed w-[300px] right-[64px] bottom-[144px] z-[1500]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessModal/* default */.Z, {
                    opened: successOpened,
                    setOpened: setSuccessOpened,
                    desc: "Form successfully submitted",
                    className: "bg-brand2 !text-white rounded-lg"
                })
            })
        ]
    });
};
/* harmony default export */ var Editor = (CampaignEditor);


/***/ }),

/***/ 49003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58036);
/* harmony import */ var _form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85119);





var SuccessModal = function(param) {
    var opened = param.opened, setOpened = param.setOpened, desc = param.desc, className = param.className, showIcon = param.showIcon;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (opened) {
            var timer = setTimeout(function() {
                setOpened(false);
            }, 3000);
            return function() {
                clearTimeout(timer);
            };
        }
    }, [
        opened
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Transition */ .u, {
        mounted: opened,
        transition: "slide-up",
        duration: 200,
        timingFunction: "ease",
        children: function(styles) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-white text-dark1 shadow-card p-7 z-20 relative ".concat(className),
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, styles),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "font-bold flex items-center",
                        children: [
                            showIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__/* .CheckIcon */ .nQ, {
                                className: "mr-2",
                                fill: "#47BA00"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: desc
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/form_images/success.gif",
                        width: 150,
                        className: "pointer-events-none bg-transparent absolute -z-10 scale-[2] left-[24%] -top-[-10%]"
                    })
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SuccessModal);


/***/ }),

/***/ 74963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAccount; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69077);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27234);
/* harmony import */ var _form_services_account__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86748);
/* harmony import */ var _rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47245);







function useAccount() {
    var ref = (0,wagmi__WEBPACK_IMPORTED_MODULE_3__/* .useAccount */ .mA)(), isConnected = ref.isConnected, address = ref.address, status = ref.status;
    var openConnectModal = (0,_rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__/* .useConnectModal */ .We)().openConnectModal;
    var disconnect = (0,wagmi__WEBPACK_IMPORTED_MODULE_3__/* .useDisconnect */ .qL)().disconnect;
    var session = (0,_stores__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.account.session;
    });
    var isLogin = (0,_form_services_account__WEBPACK_IMPORTED_MODULE_2__/* .checkLogin */ .Xx)(session) && isConnected && status === "connected";
    var isAdmin = session ? session.isAdmin : false;
    var login = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            _stores__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_1__/* .actions.account.startLogin */ .Nw.account.startLogin());
            if (!isConnected && openConnectModal) {
                openConnectModal();
            }
            return [
                2
            ];
        });
    }), [
        isConnected,
        openConnectModal
    ]);
    return {
        login: login,
        logout: disconnect,
        isLogin: isLogin,
        address: address,
        isAdmin: isAdmin
    };
}


/***/ }),

/***/ 13810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _form_services_campaign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34913);
/* harmony import */ var _useGlobalState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61254);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90387);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _form_components_form_modules_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5064);
/* harmony import */ var _useAccount__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74963);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8891);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(mixpanel_browser__WEBPACK_IMPORTED_MODULE_6__);











function extraFormTrackData(form) {
    var data = {};
    form.form.blocks.forEach(function(block) {
        if (block.module.id === "title") {
            data.name = block.values.title;
        } else if (block.module.id === "twitter") {
            data.twitter = block.values.accounts.join(",");
        } else if (block.module.id === "website") {
            data.website = block.values.link;
        } else if (block.module.id === "discord") {
            data.discord = block.values.serverLinks.join(",");
        }
    });
    return data;
}
var useForm = function(id) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_useGlobalState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("activeForm"), 2), form = ref[0], setForm = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var router = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref3 = (0,_useAccount__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), isLogin = ref3.isLogin, login = ref3.login, address = ref3.address;
    var isOwner = form && form.creator_address === address || form && !form.id;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (id) {
            if (form && form.id === id) {
                return;
            }
            if (id === "new" || id === "preview") {
                return;
            }
            setLoading(true);
            (0,_form_services_campaign__WEBPACK_IMPORTED_MODULE_1__/* .getCampaign */ .l9)(id).then(function(form) {
                setForm(form);
            }).catch(function(e) {
                setError(e.message);
            }).finally(function() {
                setLoading(false);
            });
        }
    }, [
        id,
        form
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (id && id === "new") {
            if (form && !form.id) {
                return;
            }
            setForm((0,_form_components_form_modules_index__WEBPACK_IMPORTED_MODULE_4__/* .getDefaultForm */ .EM)());
        }
    }, [
        id,
        form
    ]);
    var createForm = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(f) {
            var _form, newform, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _form = f || form;
                        if (!isLogin) {
                            login();
                            return [
                                2,
                                false
                            ];
                        }
                        if (loading || !_form || _form.id) {
                            return [
                                2,
                                false
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setError("");
                        setLoading(true);
                        return [
                            4,
                            (0,_form_services_campaign__WEBPACK_IMPORTED_MODULE_1__/* .create */ .Ue)(_form)
                        ];
                    case 2:
                        newform = _state.sent();
                        setForm(newform);
                        mixpanel_browser__WEBPACK_IMPORTED_MODULE_6___default().track("publish_form", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                            form_id: newform.id
                        }, extraFormTrackData(_form)));
                        setTimeout(function() {
                            router.replace({
                                pathname: newform.config.type === "wallets" ? "/dashboard/forms/[id]/response" : "/dashboard/forms/[id]",
                                query: {
                                    id: newform.id
                                }
                            }, undefined, {
                                shallow: true
                            });
                        }, 50);
                        return [
                            2,
                            newform
                        ];
                    case 3:
                        e = _state.sent();
                        setError(e.message);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(f) {
            return _ref.apply(this, arguments);
        };
    }(), [
        loading,
        form,
        isLogin,
        login
    ]);
    var updateForm = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(f) {
            var _form, updateForm, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _form = f || form;
                        if (!isLogin) {
                            login();
                            return [
                                2,
                                false
                            ];
                        }
                        if (loading || !_form || !_form.id) {
                            return [
                                2,
                                false
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setError("");
                        setLoading(true);
                        return [
                            4,
                            (0,_form_services_campaign__WEBPACK_IMPORTED_MODULE_1__/* .update */ .Vx)(_form.id, _form.form)
                        ];
                    case 2:
                        updateForm = _state.sent();
                        mixpanel_browser__WEBPACK_IMPORTED_MODULE_6___default().track("update_form", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                            form_id: _form.id
                        }, extraFormTrackData(_form)));
                        setForm(updateForm);
                        setTimeout(function() {
                            router.replace({
                                pathname: "/dashboard/forms/[id]",
                                query: {
                                    id: updateForm.id
                                }
                            });
                        }, 50);
                        return [
                            2,
                            updateForm
                        ];
                    case 3:
                        e = _state.sent();
                        setError(e.message);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(f) {
            return _ref.apply(this, arguments);
        };
    }(), [
        loading,
        form,
        isLogin,
        login
    ]);
    var publishForm = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(newForm) {
            var _form;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _form = newForm || form;
                        if (!_form) {
                            return [
                                2
                            ];
                        }
                        if (!!_form.id) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            createForm(_form)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        return [
                            4,
                            updateForm(_form)
                        ];
                    case 3:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(newForm) {
            return _ref.apply(this, arguments);
        };
    }(), [
        form,
        createForm,
        updateForm
    ]);
    return {
        form: form,
        isOwner: isOwner,
        setForm: setForm,
        error: error,
        loading: loading,
        createForm: createForm,
        updateForm: updateForm,
        publishForm: publishForm
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useForm);


/***/ }),

/***/ 23365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aq": function() { return /* binding */ getResponseStatus; },
/* harmony export */   "BS": function() { return /* binding */ getSummaryWallets; },
/* harmony export */   "EC": function() { return /* binding */ toCSVJSON; },
/* harmony export */   "Fn": function() { return /* binding */ previewData; },
/* harmony export */   "H2": function() { return /* binding */ getSummary; },
/* harmony export */   "QT": function() { return /* binding */ socialAccounts; },
/* harmony export */   "ck": function() { return /* binding */ getResponse; },
/* harmony export */   "s6": function() { return /* binding */ responseToTableData; },
/* harmony export */   "xA": function() { return /* binding */ getLength; }
/* harmony export */ });
/* unused harmony export tableData */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70655);
/* harmony import */ var fakerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7729);
/* harmony import */ var fakerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fakerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _form_utils_request__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7395);






var fake = fakerator__WEBPACK_IMPORTED_MODULE_0___default()();
fake.seed(5567832);
function responseToTableData(response) {
    var ref, ref1, ref2;
    var res = {};
    res.address = response.user_address;
    if (response.twitter) {
        res.twitter = {
            handle: response.twitter.username
        };
    }
    if (response.email) {
        res.email = {
            handle: response.email
        };
    }
    res.ens = response.ens;
    res.holder = response.holder;
    res.eth = response.eth ? parseFloat(response.eth) : 0;
    res.bluechip = (response === null || response === void 0 ? void 0 : (ref = response.bluechip) === null || ref === void 0 ? void 0 : ref.holdings) || [];
    res.wallet_create_time = response.wallet_create_time;
    res.last_activity_time = response.last_activity_time;
    res.tags = response.tags || [];
    res.answer = response === null || response === void 0 ? void 0 : (ref1 = response.context) === null || ref1 === void 0 ? void 0 : ref1.question;
    res.source = response === null || response === void 0 ? void 0 : (ref2 = response.context) === null || ref2 === void 0 ? void 0 : ref2.source;
    res.social_info = response.social_info;
    res.tokenBalance = response.tokenBalance;
    return res;
}
var tableData = [];
var previewData = [
    {
        isPreview: true,
        address: "0x8e22B546B8684B1217308D03af8D51263d15E7C9",
        eth: fake.random.number(1, 200),
        holder: fake.random.boolean(),
        bluechip: [
            {
                address: "0x0000000C01915E253A7f1017C975812eDd5E8ECC",
                token: {
                    _id: "1-0xed5af388653567af2f388e6224dc7c4b3241c544",
                    name: "Azuki",
                    symbol: "AZUKI",
                    logoURI: "https://lh3.googleusercontent.com/H8jOCJuQokNqGBpkBN5wk1oZwO7LM8bNnrHCaekV2nKjnCqw6UB5oaH8XyNeBDj6bA_n1mjejzhFQUP3O1NfjFLHr3FOaeHcTOOT=s120",
                    address: "0xed5af388653567af2f388e6224dc7c4b3241c544",
                    type: "ERC721",
                    initBlock: 13975839,
                    source: "primary"
                },
                balance: 1
            },
            {
                address: "0x0000000C01915E253A7f1017C975812eDd5E8ECC",
                token: {
                    _id: "1-0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b",
                    name: "CLONE X - X TAKASHI MURAKAMI",
                    symbol: "CloneX",
                    logoURI: "https://lh3.googleusercontent.com/XN0XuD8Uh3jyRWNtPTFeXJg_ht8m5ofDx6aHklOiy4amhFuWUa0JaR6It49AH8tlnYS386Q0TW_-Lmedn0UET_ko1a3CbJGeu5iHMg=s120",
                    address: "0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b",
                    chainId: "1",
                    type: "ERC721",
                    initBlock: 13790684,
                    source: "primary"
                },
                balance: 1
            }, 
        ],
        wallet_create_time: "" + dayjs__WEBPACK_IMPORTED_MODULE_1___default()(fake.date.between(dayjs__WEBPACK_IMPORTED_MODULE_1___default()().subtract(1, "year").toDate(), dayjs__WEBPACK_IMPORTED_MODULE_1___default()().toDate())).unix(),
        last_activity_time: "" + dayjs__WEBPACK_IMPORTED_MODULE_1___default()(fake.date.between(dayjs__WEBPACK_IMPORTED_MODULE_1___default()().subtract(1, "year").toDate(), dayjs__WEBPACK_IMPORTED_MODULE_1___default()().toDate())).unix(),
        tags: []
    }, 
];
for(var i = 0; i < 50; i++){
    tableData.push({
        karatScore: fake.random.number(0, 100),
        address: "0x8e22B546B8684B1217308D03af8D51263d15E7C9",
        twitter: fake.random.boolean() ? {
            handle: "0xCharlesh"
        } : undefined,
        email: fake.random.boolean() ? {
            handle: fake.internet.email()
        } : undefined,
        eth: fake.random.number(1, 200),
        holder: fake.random.boolean(),
        bluechip: [
            {
                address: "0x0000000C01915E253A7f1017C975812eDd5E8ECC",
                token: {
                    _id: "1-0xed5af388653567af2f388e6224dc7c4b3241c544",
                    name: "Azuki",
                    symbol: "AZUKI",
                    logoURI: "https://lh3.googleusercontent.com/H8jOCJuQokNqGBpkBN5wk1oZwO7LM8bNnrHCaekV2nKjnCqw6UB5oaH8XyNeBDj6bA_n1mjejzhFQUP3O1NfjFLHr3FOaeHcTOOT=s120",
                    address: "0xed5af388653567af2f388e6224dc7c4b3241c544",
                    type: "ERC721",
                    initBlock: 13975839,
                    source: "primary"
                },
                balance: 1
            },
            {
                address: "0x0000000C01915E253A7f1017C975812eDd5E8ECC",
                token: {
                    _id: "1-0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b",
                    name: "CLONE X - X TAKASHI MURAKAMI",
                    symbol: "CloneX",
                    logoURI: "https://lh3.googleusercontent.com/XN0XuD8Uh3jyRWNtPTFeXJg_ht8m5ofDx6aHklOiy4amhFuWUa0JaR6It49AH8tlnYS386Q0TW_-Lmedn0UET_ko1a3CbJGeu5iHMg=s120",
                    address: "0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b",
                    chainId: "1",
                    type: "ERC721",
                    initBlock: 13790684,
                    source: "primary"
                },
                balance: 1
            }, 
        ],
        wallet_create_time: "" + dayjs__WEBPACK_IMPORTED_MODULE_1___default()(fake.date.between(dayjs__WEBPACK_IMPORTED_MODULE_1___default()().subtract(1, "year").toDate(), dayjs__WEBPACK_IMPORTED_MODULE_1___default()().toDate())).unix(),
        last_activity_time: "" + dayjs__WEBPACK_IMPORTED_MODULE_1___default()(fake.date.between(dayjs__WEBPACK_IMPORTED_MODULE_1___default()().subtract(1, "year").toDate(), dayjs__WEBPACK_IMPORTED_MODULE_1___default()().toDate())).unix(),
        tags: []
    });
}
var getResponse = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(campaignId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _form_utils_request__WEBPACK_IMPORTED_MODULE_3__/* ["default"].rpc */ .Z.rpc("campaign_response/get_campaign_response", {
                            campaign_id: campaignId
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getResponse(campaignId) {
        return _ref.apply(this, arguments);
    };
}();
function socialAccounts(item) {
    var ref, ref1, ref2;
    var accounts = [];
    if (item === null || item === void 0 ? void 0 : (ref = item.social_info) === null || ref === void 0 ? void 0 : ref.email) {
        accounts.push(item.social_info.email);
    }
    if (item === null || item === void 0 ? void 0 : (ref1 = item.social_info) === null || ref1 === void 0 ? void 0 : ref1.twitter) {
        accounts.push(item.social_info.twitter);
    }
    if (item === null || item === void 0 ? void 0 : (ref2 = item.social_info) === null || ref2 === void 0 ? void 0 : ref2.discord) {
        accounts.push(item.social_info.discord);
    }
    return accounts;
}
function toCSVJSON(items) {
    var data = lodash__WEBPACK_IMPORTED_MODULE_2___default().cloneDeep(items);
    return data.map(function(item) {
        var ref, ref1, ref2;
        if (item.email) {
            item.email = item.email.handle;
        }
        if (item.bluechip) {
            item.bluechip = item.bluechip.map(function(item) {
                return item.token.name;
            });
        }
        item.wallet_create_time = item.wallet_create_time ? dayjs__WEBPACK_IMPORTED_MODULE_1___default().unix(parseInt(item.wallet_create_time)).toLocaleString() : "";
        item.last_activity_time = item.last_activity_time ? dayjs__WEBPACK_IMPORTED_MODULE_1___default().unix(parseInt(item.last_activity_time)).toLocaleString() : "";
        if (item === null || item === void 0 ? void 0 : (ref = item.social_info) === null || ref === void 0 ? void 0 : ref.twitter) {
            item.twitter = item.social_info.twitter.username;
        }
        if (item === null || item === void 0 ? void 0 : (ref1 = item.social_info) === null || ref1 === void 0 ? void 0 : ref1.discord) {
            item.discord = item.social_info.discord.global_name || item.social_info.discord.username;
        }
        if (item === null || item === void 0 ? void 0 : (ref2 = item.social_info) === null || ref2 === void 0 ? void 0 : ref2.email) {
            item.email = item.social_info.email.email;
        }
        delete item.social_info;
        return item;
    });
}
var getSummary = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(campaignId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (campaignId === "new") {
                        return [
                            2,
                            [
                                {
                                    id: "balance",
                                    minBalance: 1,
                                    amount: 0
                                },
                                {
                                    id: "social",
                                    amount: 0
                                },
                                {
                                    id: "recurring",
                                    amount: 0
                                },
                                {
                                    id: "holder",
                                    amount: 0
                                },
                                {
                                    id: "has_similar_asset",
                                    amount: 0
                                }
                            ]
                        ];
                    }
                    return [
                        4,
                        _form_utils_request__WEBPACK_IMPORTED_MODULE_3__/* ["default"].rpc */ .Z.rpc("campaign_response/get_summary", {
                            campaign_id: campaignId
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getSummary(campaignId) {
        return _ref.apply(this, arguments);
    };
}();
var getLength = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(campaignId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _form_utils_request__WEBPACK_IMPORTED_MODULE_3__/* ["default"].rpc */ .Z.rpc("campaign_response/get_length", {
                            campaign_id: campaignId
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getLength(campaignId) {
        return _ref.apply(this, arguments);
    };
}();
var getResponseStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(campaignId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _form_utils_request__WEBPACK_IMPORTED_MODULE_3__/* ["default"].rpc */ .Z.rpc("campaign_response/get_response_status", {
                            campaign_id: campaignId
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getResponseStatus(campaignId) {
        return _ref.apply(this, arguments);
    };
}();
var getSummaryWallets = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(campaignId, summary) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _form_utils_request__WEBPACK_IMPORTED_MODULE_3__/* ["default"].rpc */ .Z.rpc("campaign_response/get_summary_wallets", {
                            campaign_id: campaignId,
                            summary: summary
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getSummaryWallets(campaignId, summary) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ pageView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _form_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7395);



var pageView = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _form_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("stat/page_view", {})
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function pageView() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 54423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M5": function() { return /* binding */ discordUserLink; },
/* harmony export */   "Ot": function() { return /* binding */ googleMapLink; },
/* harmony export */   "cO": function() { return /* binding */ etherscanAddressLink; },
/* harmony export */   "k": function() { return /* binding */ lastActiveDesc; },
/* harmony export */   "mJ": function() { return /* binding */ walletAge; },
/* harmony export */   "nM": function() { return /* binding */ trimAddr; },
/* harmony export */   "ny": function() { return /* binding */ googleCalendarLink; },
/* harmony export */   "qD": function() { return /* binding */ dateShortDesc; },
/* harmony export */   "qI": function() { return /* binding */ trimAddr2; },
/* harmony export */   "su": function() { return /* binding */ emailLink; },
/* harmony export */   "tq": function() { return /* binding */ twitterUserLink; },
/* harmony export */   "x6": function() { return /* binding */ numberWithCommas; }
/* harmony export */ });
/* unused harmony exports trimAddr1, telegramUserLink, relativeDateDesc, normalizeUrl */
/* harmony import */ var datebook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21817);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1646);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2__);




dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2___default()));
var trimAddr = function(addr) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    return (addr === null || addr === void 0 ? void 0 : addr.substring(0, n + 2)) + "..." + (addr === null || addr === void 0 ? void 0 : addr.slice(-n));
};
var trimAddr1 = function(addr) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    return (addr === null || addr === void 0 ? void 0 : addr.substring(0, n)) + "..." + (addr === null || addr === void 0 ? void 0 : addr.slice(-n));
};
var trimAddr2 = function(addr) {
    return (addr === null || addr === void 0 ? void 0 : addr.substring(0, 18)) + "..." + (addr === null || addr === void 0 ? void 0 : addr.slice(-14));
};
function twitterUserLink(account) {
    return "https://twitter.com/".concat(account);
}
function discordUserLink(uid) {
    return "https://discordapp.com/users/".concat(uid);
}
function googleMapLink(location) {
    return "https://www.google.com/maps/place/".concat(location.replaceAll(" ", "+"));
}
function telegramUserLink(user) {
    return "";
}
function emailLink(email) {
    return "mailto:".concat(email);
}
function etherscanAddressLink(address) {
    return "https://etherscan.io/address/".concat(address);
}
function googleCalendarLink(config) {
    return new datebook__WEBPACK_IMPORTED_MODULE_0__/* .GoogleCalendar */ .eg(config).render();
}
function dateShortDesc(date) {
    var day = dayjs__WEBPACK_IMPORTED_MODULE_1___default()(date);
    if (day.isSame(dayjs__WEBPACK_IMPORTED_MODULE_1___default()(), "year")) {
        return day.format("MM/DD");
    } else {
        return day.format("MM/DD/YYYY");
    }
}
function relativeDateDesc(date) {
    var _$duration = dayjs.duration(dayjs().diff(dayjs(date)));
    var years = _$duration.asYears();
    var months = _$duration.asMonths();
    var days = _$duration.asDays();
    if (years > 1) {
        return "".concat(Math.floor(years), " years ago");
    } else if (months > 1) {
        return "".concat(Math.floor(months), " month ago");
    } else if (days > 60) {
        return ">60 days ago";
    } else if (days < 1) {
        return "".concat(Math.floor(_$duration.hours()), " hours ago");
    } else {
        return "".concat(Math.floor(days), " days ago");
    }
}
function walletAge(date) {
    var _$duration = dayjs__WEBPACK_IMPORTED_MODULE_1___default().duration(dayjs__WEBPACK_IMPORTED_MODULE_1___default()().diff(dayjs__WEBPACK_IMPORTED_MODULE_1___default()(date)));
    var years = _$duration.asYears();
    var months = _$duration.asMonths();
    var days = _$duration.asDays();
    if (years > 1) {
        return "".concat(Math.floor(years), " year");
    } else if (months > 1) {
        return "".concat(Math.floor(months), " month");
    } else if (days > 1) {
        return "".concat(Math.floor(days), " day");
    } else {
        return "today";
    }
}
function lastActiveDesc(date) {
    var _$duration = dayjs__WEBPACK_IMPORTED_MODULE_1___default().duration(dayjs__WEBPACK_IMPORTED_MODULE_1___default()().diff(dayjs__WEBPACK_IMPORTED_MODULE_1___default()(date)));
    var days = _$duration.asDays();
    if (days < 1) {
        return "today";
    } else if (days > 60) {
        return "over 60 days ago";
    } else {
        return "".concat(Math.floor(days), " days ago");
    }
}
function normalizeUrl() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    try {
        var expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
        if (text.match(expression)) {
            return _normalizeUrl(text);
        }
        return text;
    } catch (e) {
        return text;
    }
}
function numberWithCommas() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


/***/ }),

/***/ 59391:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(n){return{all:n=n||new Map,on:function(t,e){var i=n.get(t);i?i.push(e):n.set(t,[e])},off:function(t,e){var i=n.get(t);i&&(e?i.splice(i.indexOf(e)>>>0,1):n.set(t,[]))},emit:function(t,e){var i=n.get(t);i&&i.slice().map(function(n){n(e)}),(i=n.get("*"))&&i.slice().map(function(n){n(t,e)})}}}
//# sourceMappingURL=mitt.mjs.map


/***/ })

}]);